import React from 'react';
import { TileProps } from './Types';
import styled from '@emotion/styled';

const Tile = ({ text, backgroundColor, tileFontStyle }: TileProps) => {
  return (
    <div
      className="text-black p-4 flex items-center relative z-41"
      style={{
        backgroundColor: backgroundColor || 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0px 8px 10px 0px rgba(0, 0, 0, 0.30)',
      }}
    >
      <StyledText className="relative z-50" tileFontStyle={tileFontStyle}>
        {text}
      </StyledText>
    </div>
  );
};

const StyledText = styled.p<{
  tileFontStyle?: any;
}>(({ tileFontStyle }) => ({
  color: '#000',
  fontFamily: tileFontStyle?.fontFamily || '"Source Sans 3"',
  fontSize: '22px',
  fontStyle: 'normal',
  fontWeight: tileFontStyle?.fontWeight || 500,
  lineHeight: tileFontStyle?.lineHeight || 'normal',
  textTransform: 'capitalize',
  ...(tileFontStyle && {
    ...(tileFontStyle.textColor && { color: tileFontStyle.textColor }),
    ...(tileFontStyle.fontSize && { fontSize: tileFontStyle.fontSize }),
    ...(tileFontStyle.lineHeight && { lineHeight: tileFontStyle.lineHeight }),
    ...(tileFontStyle.letterSpacing && {
      letterSpacing: tileFontStyle.letterSpacing,
    }),
  }),
}));

export default Tile;
